/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QaEquipmentStateOfUse = {
    InAdding: 'InAdding',
    InEditing: 'InEditing',
    NotRegistered: 'NotRegistered',
    DeRegistered: 'DeRegistered',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    Archived: 'Archived',
    Deleted: 'Deleted'
} as const;
export type QaEquipmentStateOfUse = typeof QaEquipmentStateOfUse[keyof typeof QaEquipmentStateOfUse];


export function QaEquipmentStateOfUseFromJSON(json: any): QaEquipmentStateOfUse {
    return QaEquipmentStateOfUseFromJSONTyped(json, false);
}

export function QaEquipmentStateOfUseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaEquipmentStateOfUse {
    return json as QaEquipmentStateOfUse;
}

export function QaEquipmentStateOfUseToJSON(value?: QaEquipmentStateOfUse | null): any {
    return value as any;
}

/**
 * Check if a given object implements the QaEquipmentStateOfUse interface.
 */
 export function instanceOfQaEquipmentStateOfUse(value: any): value is QaEquipmentStateOfUse {
    return Object.values(QaEquipmentStateOfUse).includes(value)
}

